export const getAllTrainingProgramsInfo = () =>
    `query getAllTrainingProgramsInfo {
        trainingProgramsInfo {
            id
            name
            deviceType {
                id
                name
                permissionGroupId
                permissionGroupName
            }
            stages {
                id
                name
                order
            }
            applicableLocations {
                locationId
            }
        }
    }`;
